import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { CustomConfigService, SelectCustomConfigApiParameter } from "@tSurya/Services/SelectCustomConfig";

type SubmitCustomSubmitOrder = HasOnSuccess & SelectCustomConfigApiParameter & HasOnError;

type CustomHandlerType = ApiHandlerDiscreteParameter<SubmitCustomSubmitOrder, SelectCustomConfigApiParameter, any>;

const CustomPopulateApiParameter: CustomHandlerType = props => {
    props.apiParameter = {
        ...props.parameter
    }
    };


const CustomSendDataToApi: CustomHandlerType = async props => {
    try {
        const result = await CustomConfigService(props.apiParameter);
        props.apiResult = {
            success: true,
        };
    } catch (err) {
        props.apiResult = {
            success: false,
        };
    }
};

export const ExecuteOnSuccessCallback: CustomHandlerType = props => {
    if (props.apiResult.success) {
        props.parameter.onSuccess?.();
    }
};

export const ExecuteOnErrorCallback: CustomHandlerType = props => {
    if (!props.apiResult.success) {
        props.parameter.onError?.();
    }
};

export const chain = [
    CustomPopulateApiParameter,
    CustomSendDataToApi,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
];

const sendCustomConfig = createHandlerChainRunner(chain, "submitCustomConfig");
export default sendCustomConfig;
